import { render, staticRenderFns } from "./QueueRetweetCard.vue?vue&type=template&id=64c3da00&"
import script from "./QueueRetweetCard.vue?vue&type=script&lang=js&"
export * from "./QueueRetweetCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports